module.exports = __webpack_public_path__ + "static/media/instructivoaf1.b391dbf8.png";